import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../globals';
import { environment } from '../../environments/environment';
import { RegTokenServiceService } from './reg-token-service.service';
import { Router } from '@angular/router';
import { RegUser } from '../pages/basic-reg/RegUser';
import { throwError } from 'rxjs';
import { EncryptionUtil } from '../util/EncryptionUtil';
import { AppConfig } from './AppConfig';
import { AppPropService } from './app-prop.service';


@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {

  appConfig!: AppConfig;

  constructor(private globals: Globals, private http: HttpClient, private router: Router,
    private regTokenService: RegTokenServiceService, private appPropService: AppPropService) {
    this.loadAppPropConfig();
  }

  public loadAppPropConfig() {
    setTimeout(() => {
      if (this.appConfig == undefined) {
        this.appConfig = this.appPropService.appConfig;
        this.loadAppPropConfig();
      }
    }, 2000);
  }

  public getAuthHeaders = () => ({
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.getToken()
    })
  });

  public getHeaders = () => ({
    headers: new HttpHeaders({
      Accept: 'application/json',
    })
  });

  public getNoSecure = (path: string) =>{
    return this.http.get(environment.base + path, this.getHeaders());
  }

  public getNoSecurePayment =  (path: string) => {
    return this.http.get(environment.paymentURL + path, this.getHeaders());
  }

  public get =  (path: string) => {
    if (!this.authorized()) {
      this.unauthorized();
    }
    return this.http.get(environment.base + path, this.getAuthHeaders());
  }

  public postNoSecure =  (path: string, data: any) => {
    return this.http.post(environment.base + path, data, this.getHeaders());
  }

  public post =  (path: string, data: any) => {
    if (!this.authorized()) {
      this.unauthorized();
      return null;
    }
    try {
      return this.http.post(environment.base + path, data, this.getAuthHeaders());
    } catch (exp) {
      this.unauthorized();
      return null;
    }
  }

  public postWithToken =  (path: string, data: any, token: string) => {
    if (this.globals.isEmpty(token)) {
      this.unauthorized();
      return null;
    }
    try {
      return this.http.post(environment.base + path, data, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JSON.parse(token as string)
        })
      });
    } catch (exp) {
      this.unauthorized();
      return null;
    }
  }

  public loginOld = (email: any, phoneNumber: any, password: any) => {
    let loginData = {
      email: email,
      phoneNumber: phoneNumber,
      password: window.btoa(password)
    };
    var path = 'oauth/token?requestPath=appLogin';
    return this.postDefaultEncrypt(path, loginData);
  }

  public loginTemp = (deviceId: any, signupTime: any) => {
    var path = 'oauth/token?requestPath=tempLogin&deviceId=' + deviceId + "&signupTime=" + signupTime;
    return this.getNoSecure(path);
  }

  public login = (adjustedFlagTime: any, encounterNo: any) => {
    var path = 'oauth/token?requestPath=login&adjustedFlagTime=' + adjustedFlagTime + "&encounterNo=" + encounterNo;
    return this.getNoSecure(path);
  }

  public logout = () => {
    this.globals.logout();
  }

  public authorized = () => {

    if (this.getToken()) {
      return true;
    }
    return false;
  }

  public getToken = () => {

    var tokenString = this.globals.getLocalData(this.globals.HIDDIN_TOKEN);

    if (this.globals.isEmpty(tokenString)) {
      return null;
    }

    return JSON.parse(tokenString as string);
  }

  public isLoggedIn = () => {
    if (this.globals.isEmpty(this.getToken())) {
      return false;
    }
    return true;
  }

  public getLoggedInUser = (): RegUser => {
    var user = this.globals.getLocalData(this.globals.HIDDIN_USER_DETAILS);

    if (this.globals.isEmpty(user)) {
      return null!;
    } else {
      var loggedInUser = JSON.parse(user as string);
      loggedInUser.imageUrl = this.getProfilePicture();
      return loggedInUser;
    }

  }

  public getSubscription = () => {
    var isExpired = true;
    try {
      isExpired = JSON.parse(this.globals.getLocalData(this.globals.SUBSCRIPTION) as string);
    } catch (error) {
      this.router.navigate(['/error', '401']);
    }
    return isExpired;
  }

  public getProfilePicture() {
    if (this.isLoggedIn()) {
      return this.globals.getLocalData(this.globals.USER_IMAGE_URL);
    }
    return null;
  }

  public getNoSecureCore =  (path: string) => {
    return this.http.get(environment.hiddinURL + path, this.getHeaders());
  }

  public getSecureCore =  (path: string) => {
    return this.http.get(environment.hiddinURL + path, this.getAuthHeaders());
  }

  public postNoSecureCore =  (path: string, data: any) => {
    return this.http.post(environment.hiddinURL + path, data, this.getHeaders());
  }

  public unauthorized =  () => {
    this.globals.unauthorized();
  }

  public error404 =  () => {
    this.router.navigate(['/error', '404']);
  }

  public error500 =  () => {
    this.router.navigate(['/error', '500']);
  }

  public postEncrypt =  (path: string, data: any) => {

    if (!this.authorized()) {
      this.unauthorized();
    }

    if (!environment.isEncryptionEnable) {
      return this.http.post(environment.base + path, data, this.getAuthHeaders());
    }

    var dataStr = JSON.stringify(data);
    // console.log("Data to send: " + dataStr);

    var encryptedKey = this.globals.getCombineAesKey();
    // console.log("encryptedKey: " + encryptedKey);

    if (this.globals.isEmpty(encryptedKey)) {
      //console.log("Invalid AES Key");
      throwError("Invalid AES Key");
    }

    var encryptedData;
    if (!this.globals.isEmpty(data)) {
      encryptedData = EncryptionUtil.encrypt(encryptedKey, dataStr);
      // console.log("encryptedData: " + encryptedData);
    }

    // Append encrypted parameter; encrypted=true
    if (path.indexOf("?") >= 0) {
      path = path + "&encrypted=true&defaultEncrypted=false";
    } else {
      path = path + "?encrypted=true&defaultEncrypted=false";
    }

    return this.http.post(environment.base + path, encryptedData, this.getAuthHeaders());
  }

  public postEncryptCore =  (path: string, data: any) => {

    if (!this.authorized()) {
      this.unauthorized();
    }

    if (!environment.isEncryptionEnable) {
      return this.http.post(environment.hiddinURL + path, data, this.getAuthHeaders());
    }

    var dataStr = JSON.stringify(data);
    // console.log("Data to send: " + dataStr);

    var encryptedKey = this.globals.getCombineAesKey();
    // console.log("encryptedKey: " + encryptedKey);

    if (this.globals.isEmpty(encryptedKey)) {
      //console.log("Invalid AES Key");
      throwError("Invalid AES Key");
    }

    var encryptedData;
    if (!this.globals.isEmpty(data)) {
      encryptedData = EncryptionUtil.encrypt(encryptedKey, dataStr);
      // console.log("encryptedData: " + encryptedData);
    }

    // Append encrypted parameter; encrypted=true
    if (path.indexOf("?") >= 0) {
      path = path + "&encrypted=true&defaultEncrypted=false";
    } else {
      path = path + "?encrypted=true&defaultEncrypted=false";
    }

    return this.http.post(environment.hiddinURL + path, encryptedData, this.getAuthHeaders());
  }

  public postDefaultEncrypt =  (path: string, data: any) => {

    if (!environment.isEncryptionEnable) {
      return this.postNoSecure(path, data);
    }

    var dataStr = JSON.stringify(data);
    // console.log('[postDefaultEncrypt] Stringified data:', dataStr);

    var encryptedData;
    if (!this.globals.isEmpty(data)) {
      // console.log('[postDefaultEncrypt] Using encryption key:', this.appConfig?.pop);
      encryptedData = EncryptionUtil.encryptDefault(this.appConfig.pop, dataStr);
      // console.log('[postDefaultEncrypt] Encrypted data:', encryptedData);
    };

    // Append encrypted parameter; encrypted=true
    if (path.indexOf("?") >= 0) {
      path = path + "&encrypted=true&defaultEncrypted=true";
    } else {
      path = path + "?encrypted=true&defaultEncrypted=true";
    }

    if (!encryptedData) {
      console.error('[postDefaultEncrypt] ERROR: Encrypted payload is missing! Aborting request.');
      throw new Error('Encryption key missing or encryption failed.');
    }

    return this.postNoSecure(path, encryptedData);
 }

  public postDefaultEncryptCore =  (path: string, data: any) => {

    if (!environment.isEncryptionEnable) {
      return this.http.post(environment.hiddinURL + path, data, this.getHeaders());
    }

    var dataStr = JSON.stringify(data);
    // console.log("Data to send: " + dataStr);

    var encryptedData;
    if (!this.globals.isEmpty(data)) {
      encryptedData = EncryptionUtil.encryptDefault(this.appConfig.pop, dataStr);
      // console.log("encryptedData: " + encryptedData);
    }

    // Append encrypted parameter; encrypted=true
    if (path.indexOf("?") >= 0) {
      path = path + "&encrypted=true&defaultEncrypted=true";
    } else {
      path = path + "?encrypted=true&defaultEncrypted=true";
    }

    return this.http.post(environment.hiddinURL + path, encryptedData, this.getHeaders());
  }

  public postEcryptWithToken =  (path: string, data: any, token: string) => {
    if (this.globals.isEmpty(token)) {
      this.unauthorized();
    }

    if (!environment.isEncryptionEnable) {
      return this.http.post(environment.base + path, data, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JSON.parse(token as string)
        })
      });
    }

    var dataStr = JSON.stringify(data);
    // console.log("Data to send: " + dataStr);

    var encryptedData;
    if (!this.globals.isEmpty(data)) {
      encryptedData = EncryptionUtil.encryptDefault(this.appConfig.pop, dataStr);
      // console.log("encryptedData: " + encryptedData);
    }

    // Append encrypted parameter; encrypted=true
    if (path.indexOf("?") >= 0) {
      path = path + "&encrypted=true&defaultEncrypted=true";
    } else {
      path = path + "?encrypted=true&defaultEncrypted=true";
    }

    return this.http.post(environment.base + path, encryptedData, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(token as string)
      })
    });
  }
}
